import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function ArticlePage({ get_article_endpoint }) {
	const { id } = useParams();
	const [
		article,
		setArticle
	] = useState(null);
	const [
		error,
		setError
	] = useState(null);

	useEffect(
		() => {
			const fetchArticle = async () => {
				try {
					const response = await fetch(get_article_endpoint.replace('id', id));
					if (response.ok) {
						const result = await response.json();
						setArticle(result.data || null);
					} else {
						// Handle non-2xx status codes
						const errorData = await response.json();
						setError(
							errorData.message ||
								'An error occurred while fetching the article.'
						);
					}
				} catch (error) {
					// Handle network errors
					setError(
						'An error occurred while fetching the article. Please try again later.'
					);
				}
			};

			fetchArticle();
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		},
		[
			get_article_endpoint,
			id
		]
	);

	if (error) {
		return <div>Error: {error}</div>;
	}

	if (!article) {
		return <div>Loading...</div>;
	}

	return (
		<div className="w-full lg:w-1/2">
			<div className="border border-l-0 border-r-0 border-t-0 pb-10 leading-8">
				<span className="text-sm text-gray-500 mb-1 block">
					{article.category}
				</span>
				<h3 className="text-3xl font-medium">{article.title}</h3>
				<div className="font-light">
					<span className="block py-2">{article.synopsis}</span>
					<br />
					<p>{article.body}</p>
				</div>
			</div>
		</div>
	);
}

ArticlePage.propTypes = {
	get_article_endpoint: PropTypes.string.isRequired
};
